<div class="mct-flex mct-col mct-gap-27" *ngIf="fileUploadData">
  <div>
    <label class="control-label">{{ 'common.label' | translate | titlecase }}</label>
    <input
      type="text"
      class="form-control"
      [(ngModel)]="fileUploadData.LabelText"
      name="labelText"
      id="labelText"
      [placeholder]="'form-builder.legos.file-upload.default-label-text' | translate | titlecase"
    />
  </div>
  <div class="mct-flex mct-col mct-gap-5">
    <label> {{ 'form-builder.legos.file-upload.web-content-type' | translate | ucfirst }} </label>
    <p-select
      name="webContentypeId"
      appendTo="body"
      [required]="true"
      [style]="{ width: '100%' }"
      [options]="webContentTypeOptions"
      [(ngModel)]="fileUploadData.WebContentTypeId"
      [placeholder]="'common.select-one' | translate | ucfirst"
      [required]="true"
    ></p-select>
  </div>
</div>
